import React, { FC, useState } from 'react'
import { Alert, Button, Card, Col, Form, Modal, Row } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { IconContext } from 'react-icons'
import { useDispatch, useSelector } from 'react-redux'
import ICatServicios from '../../Interfaces/Catalogos/ICatServicios'
import { RootState } from '../../store/store'
import { BsEraserFill, BsFillPencilFill, BsFillTrashFill, BsSave } from 'react-icons/bs'
import DSCatServicios from '../../Services/Catalogos/CatServicios.Service'
import { updateCatServicios, deleteCatServicios } from '../../store/features/Catalogos/CatServiciosSlice'

interface IProps {}

export const CatServicios: FC<IProps> = (props) => {
  const dispatch = useDispatch()
  const mCatServicios = useSelector((state: RootState) => state.CatServicios.CatServicios)
  const [showCatClientesDialog, setShowCatClientesDialog] = useState(false)
  const [deleteCatClientesDialog, setDeleteCatClientesDialog] = useState(false)
  const [IDServicio, setIDServicio] = useState(0)
  const [Servicio, setServicio] = useState('')
  const [Search, setSearch] = useState('')
  const columnsConcepts = [
    {
      name: 'id',
      width: '80px',
      selector: (row: ICatServicios) => row.id,
      sortable: true,
    },
    {
      name: 'Servicio',
      width: '450px',
      selector: (row: ICatServicios) => row.servicio,
      sortable: true,
    },
    {
      name: 'Editar',
      width: '100px',
      cell: (row: ICatServicios) => (
        <div
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => {
            showInfo(row)
          }}
        >
          <IconContext.Provider value={{ color: 'blue', size: '21px' }}>
            <BsFillPencilFill />
          </IconContext.Provider>
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Elimina',
      width: '100px',
      cell: (row: ICatServicios) => (
        <div
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => {
            confirmDelete(row)
          }}
        >
          <IconContext.Provider value={{ color: 'red', size: '21px' }}>
            <BsFillTrashFill />
          </IconContext.Provider>
        </div>
      ),
      sortable: true,
    },
  ]

  const showInfo = (data: ICatServicios) => {
    setIDServicio(data.id)
    setServicio(data.servicio)
    setShowCatClientesDialog(true)
  }

  const confirmDelete = (data: ICatServicios) => {
    setIDServicio(data.id)
    setServicio(data.servicio)
    setDeleteCatClientesDialog(true)
  }

  const deleteInfo = () => {
    DSCatServicios.Delete(IDServicio)
      .then((response) => {
        dispatch(deleteCatServicios(IDServicio))
      })
      .catch((e: Error) => {})
    setDeleteCatClientesDialog(false)
  }

  const clearForm = () => {
    setIDServicio(0)
    setServicio('')
  }

  const saveInfo = () => {
    const data: ICatServicios = {
      id: IDServicio,
      servicio: Servicio,
      activo: 1,
    }
    DSCatServicios.Append(data)
      .then((response) => {
        dispatch(updateCatServicios(response.data))
      })
      .catch((e: Error) => {})
    setShowCatClientesDialog(false)
  }

  return (
    <div>
      <Row>
        <Col xs={12}>
          <Card style={{}}>
            <Card.Body>
              <Card.Title style={{ textAlign: 'left' }}>
                <Alert variant='primary'>Servicios</Alert>
              </Card.Title>
              <Row>
                <Col xs={12}>
                  <Form.Control
                    type='text'
                    size='sm'
                    placeholder='Search...'
                    onChange={(e) => {
                      setSearch(e.target.value)
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <DataTable
                    noHeader
                    defaultSortFieldId={'id'}
                    defaultSortAsc={true}
                    striped={true}
                    dense={true}
                    paginationPerPage={10}
                    pagination
                    highlightOnHover
                    columns={columnsConcepts}
                    data={mCatServicios.filter(function (row: ICatServicios) {
                      return row.servicio.includes(Search)
                    })}
                    pointerOnHover
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal
        show={showCatClientesDialog}
        onHide={() => {
          setShowCatClientesDialog(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Catalogo: Servicios</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={3}>No cliente</Col>
            <Col xs={2}>
              <Form.Control type='text' id='IDServicio' value={IDServicio} disabled size='sm' />
            </Col>
            <Col xs={1} style={{ textAlign: 'left' }}>
              <Button
                size='sm'
                variant='white'
                onClick={() => {
                  clearForm()
                }}
              >
                <IconContext.Provider value={{ color: 'orange', size: '25px' }}>
                  <BsEraserFill />
                </IconContext.Provider>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={2}>Cliente</Col>
            <Col xs={10}>
              <Form.Control
                type='text'
                id='Servicio'
                value={Servicio}
                size='sm'
                onChange={(e) => {
                  setServicio(e.target.value)
                }}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={2}></Col>
            <Col xs={3}>&nbsp;</Col>
            <Col xs={3}>
              <Button
                variant='primary'
                onClick={() => {
                  saveInfo()
                }}
              >
                Guarda
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
      <Modal
        show={deleteCatClientesDialog}
        onHide={() => {
          setDeleteCatClientesDialog(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Catalogo: Clientes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <br />
          <Row>
            <Col xs={12}>
              <Alert variant='warning'>
                ¿Esta seguro de que desea eliminar el servicio: <br />
                <span style={{ fontWeight: 'bold', fontSize: '20px' }}>{Servicio}</span>?
              </Alert>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={2}></Col>
            <Col xs={3}>&nbsp;</Col>
            <Col xs={3}>
              <Button
                variant='danger'
                onClick={() => {
                  deleteInfo()
                }}
              >
                Elimina
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
